export const AccountTabs = {
  USER_PROFILE: 'user-profile',
  CHANGE_PASSWORD: 'change-password',
  INFORMATION: 'information',
  NOTIFICATION: 'notifications',
  LANGUAGE: 'language',
}
